import { baseApi } from "api/BaseApi";
import { PartialWith } from "api/common/utils/type.utils";

import { Maintenance } from "./maintenance.types";

const MAINTENANCE_BASE_QUERY = "/project/maintenance";

export const maintenanceApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    getMaintenance: build.query<Maintenance, number>({
      query: (id) => `${MAINTENANCE_BASE_QUERY}/${id}/`,
      providesTags: (_result, _error, id) => [
        { type: "ASSURANCE_MAINTENANCE", id },
      ],
    }),

    maintenancesByProduct: build.query<Maintenance, number | string>({
      query: (id) => ({
        url: `${MAINTENANCE_BASE_QUERY}/get_maintenance_by_product/`,
        params: { product_id: id },
      }),
      providesTags: (_result, _error, id) => [
        { type: "ASSURANCE_MAINTENANCE", id },
      ],
    }),

    maintenanceUpdate: build.mutation<
      Maintenance,
      PartialWith<Maintenance, "maintenance_id">
    >({
      query: (maintenance) => ({
        url: `${MAINTENANCE_BASE_QUERY}/${maintenance.maintenance_id}/`,
        method: "PUT",
        body: maintenance,
      }),
      invalidatesTags: (_result, _error, { maintenance_id }) => [
        { type: "ASSURANCE_MAINTENANCE", id: maintenance_id },
      ],
    }),

    maintenanceCreateAsFormData: build.mutation<Maintenance, FormData>({
      query: (maintenance) => ({
        url: `${MAINTENANCE_BASE_QUERY}/`,
        method: "POST",
        body: maintenance,
        formData: true,
      }),
    }),

    maintenanceUpdateAsFormData: build.mutation<Maintenance, FormData>({
      query: (maintenance) => ({
        url: `${MAINTENANCE_BASE_QUERY}/${maintenance.get("maintenance_id")}/`,
        method: "PUT",
        body: maintenance,
        formData: true,
      }),
      invalidatesTags: (_result, _error, maintenance) => [
        {
          type: "ASSURANCE_MAINTENANCE",
          id: Number(maintenance.get("maintenance_id")),
        },
      ],
    }),
  }),

  overrideExisting: false,
});

export const {
  useGetMaintenanceQuery,
  useMaintenancesByProductQuery,
  useMaintenanceUpdateMutation,
  useMaintenanceCreateAsFormDataMutation,
  useMaintenanceUpdateAsFormDataMutation,
} = maintenanceApi;
